module.exports = __webpack_public_path__ + "models/scene1adults.8effc44.txt";